import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Box,
} from '@mui/material';
import useSession from 'src/hooks/useSession';
import { useLocation } from 'react-router-dom';
import RegisterBlock from 'src/components/authentication/register/RegisterBlock';
import SuccessDialog from 'src/components/booking/success/SuccessDialog';

type LocationState = {
  ics: string;
};

const BookingSuccess: FC = () => {
  const { session } = useSession();
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Kumao | Buchung abgeschlossen</title>
      </Helmet>
      <Box sx={{
        background: 'url(/static/home/search2.jpg)',
        backgroundPositionX: 'center',
        backgroundPositionY: '25%',
        backgroundSize: '100% auto',
        height: 400,
        width: '100%',
        mt: 5,
        backgroundRepeat: 'no-repeat',
        mb: 10
      }}
      />
      <RegisterBlock
        firstName={session?.userData?.firstName}
        lastName={session?.userData?.lastName}
        email={session?.userData?.userEmail}
      />
      <SuccessDialog icsEntry={location.state ? (location.state as LocationState).ics : ''} />
    </>
  );
};

export default BookingSuccess;
